<template>
  <div class="cropImageBox">
    <div class="operate-area" ref="operateArea">
      <div class="drag-area">
        <div class="canvas-container" ref="canvasContainer">
          <canvas ref="avatar" class="avatar" width="198" height="198"></canvas>
          <canvas
            ref="avatarMask"
            class="avatar-mask"
            width="300"
            height="300"
          ></canvas>
        </div>
      </div>
      <div class="scaling-control">
        <img src="@/assets/icons/shrink.png" alt="" />
        <input
          id="range"
          ref="rangeInput"
          type="range"
          :value="1"
          disabled="true"
          min="1"
          max="2"
          step="0.01"
        />
        <img src="@/assets/icons/magnify.png" alt="" />
      </div>
    </div>
    <div class="source-img-container">
      <span class="uploadImg">
        <input @change="upload($event)" type="file" />
        <span>{{ imageButton == false ? "点击上传" : "重新上传" }}</span></span
      >
    </div>
  </div>
</template>

<script>
let avatar;
let avatarMask;
let operateArea;
let canvasContainer;
let tarScalingController;
let maskCtx;
let avatarCtx;
let srcImage;
export default {
  data() {
    return {
      draging: false,
      srcWidth: 0,
      srcHeight: 0,
      avatarOffsetX: 0,
      avatarOffsetY: 0,
      maskOffsetX: 0,
      maskOffsetY: 0,
      lastScale: 1,
      tarWidth: 0,
      tarHeight: 0,
      initialTarWidth: 0,
      initialTarHeight: 0,
      boardMaskWidth: 300,
      boardMaskHeight: 300,
      boardAvatarWidth: 198,
      boardAvatarHeight: 198,
      uploadImage: "",
      imageUrl: "",
      imageButton: false,
    };
  },
  created() {
    this.$nextTick(() => {
      avatar = this.$refs.avatar;
      avatarMask = this.$refs.avatarMask;
      operateArea = this.$refs.operateArea;
      canvasContainer = this.$refs.canvasContainer;
      tarScalingController = this.$refs.rangeInput;
      maskCtx = avatarMask.getContext("2d");
      avatarCtx = avatar.getContext("2d");
      srcImage = document.createElement("img");
    });
  },
  /* mounted() {
    const img = this.$store.state.user.info.head_img;
    this.getBase64Image(img);
  }, */
  methods: {
    getBase64Image(img) {
      const image = new Image();
      image.setAttribute("crossOrigin", "anonymous");
      const imageUrl = img;
      image.src = imageUrl;
      image.onload = () => {
        avatarCtx.drawImage(
          image,
          0,
          0,
          this.boardAvatarWidth,
          this.boardAvatarHeight
        );
        this.imageUrl = avatar.toDataURL("image/png");
      };
    },
    upload(e) {
      if (e.target.files[0] == undefined || e.target.files[0] == null) {
        return false;
      }
      tarScalingController.disabled = false;
      avatarCtx.clearRect(0, 0, this.boardAvatarWidth, this.boardAvatarHeight);
      maskCtx.clearRect(0, 0, this.boardMaskWidth, this.boardMaskHeight);
      Object.assign(this.$data, this.$options.data());
      this.imageButton = true;
      document.getElementById("range").value = 1;
      this.uploadImage = e.target.files[0];
      srcImage.src = window.URL.createObjectURL(this.uploadImage);
      const that = this;
      srcImage.onload = () => {
        that.initDrawAvatar(srcImage);
        this.imageUrl = avatar.toDataURL("image/png");
        canvasContainer.onmousedown = () => {
          that.draging = true;
        };
        operateArea.onmouseup = () => {
          that.draging = false;
        };
        operateArea.onmouseleave = () => {
          that.draging = false;
        };
        operateArea.onmousemove = (val) => {
          if (that.draging) {
            this.imageUrl = avatar.toDataURL("image/png");
            that.reDrawOnMove(srcImage, val.movementX, val.movementY);
          }
        };
        tarScalingController.onchange = (val) => {
          this.imageUrl = avatar.toDataURL("image/png");
          avatarCtx.clearRect(
            0,
            0,
            that.boardAvatarWidth,
            that.boardAvatarHeight
          );
          that.reDrawOnScaling(srcImage, val.target.value);
        };
        tarScalingController.oninput = (val) => {
          this.imageUrl = avatar.toDataURL("image/png");
          that.reDrawOnScaling(srcImage, val.target.value);
        };
      };
    },
    initDrawAvatar(image) {
      this.srcWidth = image.width;
      this.srcHeight = image.height;
      if (this.srcWidth > this.srcHeight) {
        this.tarWidth = this.initialTarWidth =
          this.boardAvatarHeight * (this.srcWidth / this.srcHeight);
        this.tarHeight = this.initialTarHeight = this.boardAvatarHeight;
      } else {
        this.tarWidth = this.initialTarWidth = this.boardAvatarWidth;
        this.tarHeight = this.initialTarHeight =
          this.boardAvatarWidth * (this.srcHeight / this.srcWidth);
      }
      this.maskOffsetX = (this.boardMaskWidth - this.tarWidth) / 2;
      this.maskOffsetY = (this.boardMaskHeight - this.tarHeight) / 2;

      this.avatarOffsetX = (this.boardAvatarWidth - this.tarWidth) / 2;
      this.avatarOffsetY = (this.boardAvatarHeight - this.tarHeight) / 2;
      avatarCtx.drawImage(
        image,
        0,
        0,
        this.srcWidth,
        this.srcHeight,
        this.avatarOffsetX,
        this.avatarOffsetY,
        this.tarWidth,
        this.tarHeight
      );
      maskCtx.drawImage(
        image,
        0,
        0,
        this.srcWidth,
        this.srcHeight,
        this.maskOffsetX,
        this.maskOffsetY,
        this.tarWidth,
        this.tarHeight
      );
    },
    reDrawOnScaling(image, scale) {
      avatarCtx.clearRect(0, 0, this.boardAvatarWidth, this.boardAvatarHeight);
      maskCtx.clearRect(0, 0, this.boardMaskWidth, this.boardMaskHeight);
      const diffWidth = this.initialTarWidth * (scale - this.lastScale);
      const diffHeight = this.initialTarHeight * (scale - this.lastScale);

      this.tarWidth = this.tarWidth + diffWidth;
      this.tarHeight = this.tarHeight + diffHeight;
      this.avatarOffsetX = this.avatarOffsetX - diffWidth / 2;
      if (this.avatarOffsetX > 0) {
        this.avatarOffsetX = 0;
        this.maskOffsetX = this.maskOffsetX - diffWidth / 2;
        this.maskOffsetX = (this.boardMaskWidth - this.boardAvatarWidth) / 2;
      } else if (this.avatarOffsetX < this.boardAvatarWidth - this.tarWidth) {
        this.avatarOffsetX = this.boardAvatarWidth - this.tarWidth;
        this.maskOffsetX =
          (this.boardMaskWidth + this.boardAvatarWidth) / 2 - this.tarWidth;
      } else {
        this.maskOffsetX = this.maskOffsetX - diffWidth / 2;
      }
      this.avatarOffsetY = this.avatarOffsetY - diffHeight / 2;
      if (this.avatarOffsetY > 0) {
        this.avatarOffsetY = 0;
        this.maskOffsetY = (this.boardMaskHeight - this.boardAvatarHeight) / 2;
      } else if (this.avatarOffsetY < this.boardAvatarHeight - this.tarHeight) {
        this.avatarOffsetY = this.boardAvatarHeight - this.tarHeight;
        this.maskOffsetY =
          (this.boardMaskHeight + this.boardAvatarHeight) / 2 - this.tarHeight;
      } else {
        this.maskOffsetY = this.maskOffsetY - diffHeight / 2;
      }
      this.lastScale = scale;
      avatarCtx.drawImage(
        image,
        0,
        0,
        this.srcWidth,
        this.srcHeight,
        this.avatarOffsetX,
        this.avatarOffsetY,
        this.tarWidth,
        this.tarHeight
      );
      maskCtx.drawImage(
        image,
        0,
        0,
        this.srcWidth,
        this.srcHeight,
        this.maskOffsetX,
        this.maskOffsetY,
        this.tarWidth,
        this.tarHeight
      );
    },
    reDrawOnMove(image, moveX, moveY) {
      avatarCtx.clearRect(0, 0, this.boardAvatarWidth, this.boardAvatarHeight);
      maskCtx.clearRect(0, 0, this.boardMaskWidth, this.boardMaskHeight);
      const newAvatarOffseX = this.avatarOffsetX + moveX;
      const newAvatarOffsetY = this.avatarOffsetY + moveY;
      if (newAvatarOffseX > 0) {
        this.avatarOffsetX = 0;
        this.maskOffsetX = (this.boardMaskWidth - this.boardAvatarWidth) / 2;
      } else if (newAvatarOffseX < this.boardAvatarWidth - this.tarWidth) {
        this.avatarOffsetX = this.boardAvatarWidth - this.tarWidth;
        this.maskOffsetX =
          (this.boardMaskWidth + this.boardAvatarWidth) / 2 - this.tarWidth;
      } else {
        this.avatarOffsetX = newAvatarOffseX;
        this.maskOffsetX = this.maskOffsetX + moveX;
      }
      if (newAvatarOffsetY > 0) {
        this.avatarOffsetY = 0;
        this.maskOffsetY = (this.boardMaskHeight - this.boardAvatarHeight) / 2;
      } else if (newAvatarOffsetY < this.boardAvatarHeight - this.tarHeight) {
        this.avatarOffsetY = this.boardAvatarHeight - this.tarHeight;
        this.maskOffsetY =
          (this.boardMaskHeight + this.boardAvatarHeight) / 2 - this.tarHeight;
      } else {
        this.avatarOffsetY = newAvatarOffsetY;
        this.maskOffsetY = this.maskOffsetY + moveY;
      }

      maskCtx.drawImage(
        image,
        0,
        0,
        this.srcWidth,
        this.srcHeight,
        this.maskOffsetX,
        this.maskOffsetY,
        this.tarWidth,
        this.tarHeight
      );
      avatarCtx.drawImage(
        image,
        0,
        0,
        this.srcWidth,
        this.srcHeight,
        this.avatarOffsetX,
        this.avatarOffsetY,
        this.tarWidth,
        this.tarHeight
      );
    },
  },
};
</script>

<style lang="less" scoped>
.cropImageBox {
  margin-top: 30px;
  display: flex;
  .operate-area {
    display: flex;
    flex-direction: column;
    .drag-area {
      height: 300px;
      width: 300px;
      position: relative;
      .avatar {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #ffffff;
        z-index: 1;
      }
      .avatar-mask {
        background: #f7f7f7;
        opacity: 0.3;
      }
    }
    .scaling-control {
      margin-top: 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;
      input[type="range"] {
        outline: none;
        -webkit-appearance: none;
        width: 196px !important;
        background: #f6f6f6;
        height: 4px;
      }
      input[type="range"]::-webkit-slider-thumb {
        -webkit-appearance: none;
        height: 12px;
        width: 12px;
        background: #d3d3d3;
        border-radius: 50%;
      }
      img {
        width: 20px;
        height: 20px;
      }
    }
  }
  .source-img-container {
    cursor: pointer;
    position: relative;
    .uploadImg {
      font-size: 12px;
      overflow: hidden;
      position: absolute;
      width: 56px;
      left: 40px;
      top: 10px;
      input {
        position: absolute;
        z-index: 100;
        margin-left: -180px;
        font-size: 60px;
        opacity: 0;
        filter: alpha(opacity=0);
        margin-top: -5px;
      }
      span {
        font-size: 14px;
        font-weight: 400;
        color: #c18f3a;
        line-height: 20px;
        cursor: pointer;
      }
    }
  }
}
</style>